export const borderSizes = {
  thin: '1px',
  md: '2px',
};

export const theme = {
  colors: {
    black: '#18191f',
    black900: '#333333',
    black800: '#474a57',
    black700: '#969bab',
    black300: '#9fa4b4',
    black200: '#eeeff4',
    black100: '#f4f5f7',
    gray: '#000000B2;',
    gray300: 'rgba(238, 239, 244, 1)',
    modalOverlay: 'rgba(0, 0, 0, 0.5)',
    white: '#eeeff4',
    purewhite: 'white',
    blue: '#1947e5',
    blue800: '#8094ff',
    blue100: '#e9e7fc',
    gray100: '#d9d9d9',
    gray200: '#e2e2e2',
    gray500: '#eeeeee',
    gray400: '#706f82',
    gray800: '#474A57',
    blue200: '#86C5F4',
    red300: '#E46C61',
    green: '#00c6ae',
    green800: '#61e4c5',
    green100: '#d6fcf7',
    pink: '#ff89bb',
    pink800: '#ffc7de',
    pink100: '#fff3f8',
    yellow700: '#FFCE52',
    yellow: '#ffbd12',
    yellow800: '#ffd465',
    yellow100: '#fff4cc',
    yellow200: '#F5DD9F',
    yellow400: '#FFDD85',
    yellow300: '#FFE49F',
    green200: '#BBD99B',
    blue400: '#9CABFD',
    red: '#f95a2c',
    red800: '#ff9692',
    red100: '#ffe8e8',
    red200: '#FEE7E5',
    success: '#10763A',
    success100: '#6FCF97',
    golden: '#FFD700',
    green300: 'oklch(0.871 0.15 154.449)',
  },
  space: ['0', '2px', '4px', '8px', '12px', '16px', '24px', '32px'],
  fontSizes: {
    '0': 0,
    '12': 12,
    '14': 14,
    '15': 15,
    '17': 17,
    '20': 20,
    '21': 21,
    '24': 24,
    '27': 27,
    '36': 36,
    '44': 44,
    '54': 54,
  },
  fonts: { montserrat: 'Montserrat, sans-serif' },
  fontWeights: {
    medium: 500,
    bold: 700,
    extraBold: 800,
  },
  borderRadius: '12px',
  lineHeights: {
    body: 1.5,
    title: 1.1,
  },
  borders: {
    none: 'none',
    thin: `${borderSizes.thin} solid`,
    md: `${borderSizes.md} solid`,
  },
};
